import type { Routes } from '@angular/router';
import { provideEffects } from '@ngrx/effects';

import { ForgotPasswordEffects } from './store/forgot-password/forgot-password.effects';
import { RecoveryPasswordEffects } from './store/recovery-password/recovery-password.effects';

export const authRoutes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./containers/login-page/login-page.component').then(c => c.LoginPageComponent),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./containers/forgot-password-page/forgot-password-page.component').then(c => c.ForgotPasswordPageComponent),
    providers: [provideEffects(ForgotPasswordEffects)],
  },
  {
    path: 'password-reset/:token',
    loadComponent: () =>
      import('./containers/password-recovery-page/password-recovery-page.component').then(c => c.PasswordRecoveryPageComponent),
    providers: [provideEffects(RecoveryPasswordEffects)],
  },
  {
    path: 'lariuser/:token',
    loadComponent: () => import('./containers/signup-page/signup-page.component').then(c => c.SignupPageComponent),
  },
];
